import * as React from "react";
const Article = (props) => (
  <svg
    viewBox="0 0 24 24"
    height={28}
    width={28}
    fill={props.fill}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Layer_2" data-name="Layer 2">
      <path d="m21.5 5.25h-2.75v-2.75a1.25 1.25 0 0 0 -1.25-1.25h-15a1.25 1.25 0 0 0 -1.25 1.25v16.5a3.75 3.75 0 0 0 3.75 3.75h15a2.75 2.75 0 0 0 2.75-2.75v-13.5a1.25 1.25 0 0 0 -1.25-1.25zm-10.5 13h-6a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 0 1.5zm4-3h-10a.75.75 0 0 1 0-1.5h10a.75.75 0 0 1 0 1.5zm.75-4.25a.76.76 0 0 1 -.75.75h-10a.76.76 0 0 1 -.75-.75v-5a.76.76 0 0 1 .75-.75h10a.76.76 0 0 1 .75.75zm5.5 9a1.25 1.25 0 0 1 -2.5 0v-13.25h2.5z" />
      <path d="m5.75 6.75h8.5v3.5h-8.5z" />
    </g>
  </svg>
);
export default Article;
